__turbopack_context__.v({
  "openAnimation": "Notification-module__B-NQLq__openAnimation",
  "root": "Notification-module__B-NQLq__root",
});
